<template>

  <div class="padded">
    <h3><i class="fa fa-calendar" />&nbsp;Rentals by Month</h3>
     <events-calendar category="rentals" />
   </div>


</template>

<script>

import EventsCalendar from '@/components/atoms/EventsCalendar'

export default {

  components: {
    EventsCalendar
  }

}
</script>



// WEBPACK FOOTER //
// PropertyRentalMonth.vue?16098acd